export const PARAM_NAME_TOKEN = "auth-tknv2";
export const PARAM_NAME_PRODUCTS = "products";
export const PARAM_NAME_AUTHREFRESHING = "auth-refreshing";
export const PARAM_NAME_QUERYSTRING_REDIRECTURL = "RedirectUrl";
export const PARAM_NAME_LOGIN_RELATIVE_URL = "login";
export const PARAM_NAME_PROFILE_RELATIVE_URL = "profile";
export const PARAM_NAME_PW = "SG3PlusBook";

export const PARAM_COOKIE_TRANSVERSAL_START_NAME = "sg3plus.loc";
export const PARAM_COOKIE_TRANSVERSAL_HELP_CONFIG = "sg3plus.help.enabled";
export const PARAM_COOKIE_TRANSVERSAL_BOARD_FIELD_DISPLAY = "sg3plus.skpi.boardfielddisplay";
export const PARAM_COOKIE_TRANSVERSAL_BOARD_CALENDAR_CONFIG = "sg3plus.skpi.calendarconfig";

export const PARAM_COOKIE_TRANSVERSAL_GRID_LAYOUT_TEXT = "sg3plus.grid-layout";
export const PARAM_COOKIE_TRANSVERSAL_LOCALE_CONFIG = "i18nextLng";

export const PARAM_NAME_TOKEN_OLD = "auth-token";